<template>
    <div>
        <h3 class="title mt-8 mb-4">Peringkat</h3>

        <v-skeleton-loader
            v-if="!ranks"
            type="list-item-avatar-two-line@5"
        ></v-skeleton-loader>

        <template v-else-if="ranks.length === 0">Belum ada peringkat</template>

        <template v-else>
            <v-list-item
                v-if="selfIdx !== false"
                dark
                class="primary mb-6"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ selfRank.name }}</v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                    <v-row no-gutters>
                        <v-col class="headline">#{{ selfIdx + 1 }}</v-col>
                        <v-col class="headline ml-4">
                            {{ selfRank.grade }}
                        </v-col>
                    </v-row>
                </v-list-item-action>
            </v-list-item>

            <v-list>
                <v-list-item
                    v-for="(rank, idx) in ranks"
                    :key="idx"
                    two-line
                >
                    <v-list-item-avatar color="avatar">
                        <v-img
                            v-if="rank.image"
                            :src="rank.image"
                        ></v-img>
                        <v-icon
                            v-else
                            color="white"
                        >
                            mdi-account
                        </v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>{{ rank.name }}</v-list-item-title>
                        <v-list-item-subtitle>
                            {{ rank.university }}
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-row no-gutters>
                            <v-col class="headline">#{{ idx + 1 }}</v-col>
                            <v-col class="headline ml-4">
                                {{ rank.grade }}
                            </v-col>
                        </v-row>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </template>
    </div>
</template>

<script>
import assetUrl from '@/tools/assetUrl'

export default {
    data() {
        return {
            selfIdx: null,
            ranks: null,
        }
    },

    computed: {
        selfRank() {
            return this.ranks[this.selfIdx]
        },
    },

    created() {
        this.$api
            .get(`tryout/${this.$route.params.hash}/rank`)
            .then((response) => {
                this.selfIdx = response.data.self_idx
                this.ranks = response.data.ranks.map((e) => {
                    return {
                        ...e,
                        image: e.image ? assetUrl(e.image) : null,
                    }
                })
            })
    },
}
</script>
